export const data = [
  {
    name: 'Paweł Kański',
    description: 'PR & Communications Specialist',
    linkedin: 'https://www.linkedin.com/in/pawelkanski/',
    image: 'crew/pawel-kanski.jpg',
    mail: 'pawel.kanski@boldare.com',
  },
];
